import * as yup from "yup";

export const MenuHeadSetupValidationSchema = yup.object().shape({
  name: yup.string().required("Label is required"),
  menuOrder: yup.string().required("Menu Sequence is required"),
});
